import { v4 as uuidv4 } from "uuid";
import {
  type GA4,
  sendAddToCartDatalayerEvent,
  sendBeginCheckoutDatalayerEvent,
  sendPurchaseDatalayerEvent,
  sendViewItemDatalayerEvent,
  sendViewItemListDatalayerEvent,
} from "../tagmanager";

function CheckoutEventsBuilder() {
  function plansListViewed(payload: GA4.ViewItemListPayload) {
    const uuid = uuidv4();
    sendViewItemListDatalayerEvent({
      ...payload,
      kunduz_event_id: uuid,
    } as GA4.ViewItemListPayload);
    return uuid;
  }

  function planDetailViewed(payload: GA4.ViewItemPayload) {
    const uuid = uuidv4();
    sendViewItemDatalayerEvent({
      ...payload,
      kunduz_event_id: uuid,
    } as GA4.ViewItemPayload);
    return uuid;
  }

  function planAddedToCard(payload: GA4.AddToCartPayload) {
    const uuid = uuidv4();
    sendAddToCartDatalayerEvent({
      ...payload,
      kunduz_event_id: uuid,
    } as GA4.AddToCartPayload);
    return uuid;
  }

  function beginCheckout(payload: GA4.BeginCheckoutPayload) {
    const uuid = uuidv4();
    sendBeginCheckoutDatalayerEvent({
      ...payload,
      kunduz_event_id: uuid,
    } as GA4.BeginCheckoutPayload);
    return uuid;
  }

  function purchaseSuccessful(payload: GA4.PurchasePayload) {
    const uuid = uuidv4();
    sendPurchaseDatalayerEvent({
      ...payload,
      kunduz_event_id: uuid,
    } as GA4.PurchasePayload);
    return uuid;
  }

  return Object.freeze({
    plansListViewed,
    planDetailViewed,
    planAddedToCard,
    beginCheckout,
    purchaseSuccessful,
  });
}

export const CheckoutEvents = CheckoutEventsBuilder();
